__turbopack_context__.v({
  "BottomSection": "_0quSuG_BottomSection",
  "EventDescription": "_0quSuG_EventDescription",
  "EventDetailsBottom": "_0quSuG_EventDetailsBottom",
  "EventDetailsBottomRight": "_0quSuG_EventDetailsBottomRight",
  "EventDetailsSellerAlertContainer": "_0quSuG_EventDetailsSellerAlertContainer",
  "EventLocationCard": "_0quSuG_EventLocationCard",
  "EventLocationHeader": "_0quSuG_EventLocationHeader",
  "EventLocationSubhead": "_0quSuG_EventLocationSubhead",
  "EventMapLink": "_0quSuG_EventMapLink",
  "FAQButton": "_0quSuG_FAQButton",
  "IconContainer": "_0quSuG_IconContainer",
  "RelatedEvents": "_0quSuG_RelatedEvents",
  "RelatedEventsHeader": "_0quSuG_RelatedEventsHeader",
});
